import type { StaticTextResource } from '../keys'

export const bn: StaticTextResource = {
  'schedule.dueToday': 'আজ {{time}} পর্যন্ত',
  'schedule.dueTomorrow': 'আগামীকাল {{time}} পর্যন্ত',
  'schedule.durationRange':
    '{{start}} - {{end}} (দিন {{currentDay}}/{{days}} দিন)',
  'editReport.defaultPageName': 'পৃষ্ঠা {{n}}',
  'editReport.defaultSectionName': 'বিভাগ',
  'editReport.defaultRepeatSectionName': 'পুনরাবৃত্ত বিভাগ',
}
